<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title--Front-Matter-" id="_idParaDest-1">Dorothy and t<a id="_idTextAnchor000"></a>he Wizard in Oz</p>
<p class="ORIM-Author-Name--Front-Matter- _idGenParaOverride-1">L. Frank Baum</p>
<p class="ORIM-Blockquote-Body--Body- ParaOverride-1"><img alt="logo2" src="Book1/image/logo.jpg"/><a id="_idTextAnchor004"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// WizardinOz2.vue?4dffef4a